import * as yup from 'yup';
import { isEmail, isPassword } from 'utils/validation-rules';

export const SignInSchema = yup.object({
  email: yup.string().required('Field is required').matches(isEmail, 'Email is incorrect'),
  password: yup.string().required('Field is required').matches(isPassword, 'Password is incorrect'),
});
